// Face ID / Touch ID in the browser, talking to the server's /auth routes.
import { startAuthentication, startRegistration } from '@simplewebauthn/browser';
import { ROUTES, type RegisterStart } from '@serb/shared';
import { api } from '../../api/client';

type Options<F extends (...a: never[]) => unknown> = Parameters<F>[0]['optionsJSON'];

export async function signIn(): Promise<void> {
  const optionsJSON = await api.post<Options<typeof startAuthentication>>(ROUTES.auth.loginOptions);
  await api.post(ROUTES.auth.loginVerify, await startAuthentication({ optionsJSON }));
}

export async function registerDevice(input: RegisterStart): Promise<void> {
  const optionsJSON = await api.post<Options<typeof startRegistration>>(ROUTES.auth.registerOptions, input);
  await api.post(ROUTES.auth.registerVerify, await startRegistration({ optionsJSON }));
}

export const signOut = () => api.post(ROUTES.auth.logout);

/** Browser passkey errors, in plain words */
export function passkeyErrorText(e: unknown): string {
  const name = e instanceof Error ? e.name : '';
  if (name === 'NotAllowedError') return 'Cancelled, or no SERB passkey on this device yet.';
  if (name === 'InvalidStateError') return 'This device is already set up. Just sign in.';
  return e instanceof Error && e.message ? e.message : 'Something went wrong.';
}
